import {
    SET_COMMENT,
    GET_ALL_COMMENT,
    SET_CURRENT_TAB_ID,
    CREATE_COMMENT,
    SET_ALL_COMMENTS,
    GET_COMMENT,
    REMOVE_COMMENT,
    UPDATE_COMMENT,
    RESOLVE_COMMENT,
    UPDATE_DRAFT_COMMENT,
    UPDATE_ALL_DRAFT_COMMENT,
    GET_CHANGELOG_BY_ID,
    SET_CHANGELOG,
    EXPORT_SUMMARY,
} from 'store/key';
import { put, select, takeEvery, call } from 'redux-saga/effects';
import { safeSaga } from 'store';
import api from 'api/call';
import { commentStatusEnum } from 'constants/globalEnum';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';

const initialState = {
    addBox: {
        Label: "",
        isShow: false,
        questionNo: "",
        questionField: null,
    },
    commentBox: {
        isShow: false,
        commentDetail: null,
    },
    currentTabId: '',
    allComments: null,
    changeLog: null,
};

export const setComment = (data) => {
    return {
        type: SET_COMMENT,
        payload: { ...data },
    };
};

function* getAllComments(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.getAllComments(action.payload);
        if (response?.status !== 200) return;

        yield put({
            type: SET_ALL_COMMENTS,
            payload: response?.data?.result,
        });
    } catch (error) {
        console.warn('getAllComments', error);
    } finally {
        setGlobalLoading(false);
    }
}

function* createComment(action) {
    try {
        setGlobalLoading(true);
        const { params, callback } = action.payload;
        const response = yield api.comment.createComment(params);
        if (response?.status !== 200) return;
        callback();
        yield call(getAllComments, { payload: params?.appId });
    } catch (error) {
        console.warn('createComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* getComment(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.getComment(action.payload);
        if (response?.status !== 200) return;

        yield put({
            type: SET_COMMENT,
            payload: {
                commentBox: {
                    isShow: true,
                    commentDetail: response?.data?.result,
                },
            },
        });
    } catch (error) {
        console.warn('getComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* removeComment(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.removeComment(action.payload?.id);
        if (response?.status !== 200) return;
        yield call(getAllComments, { payload: action.payload?.appId });
    } catch (error) {
        console.warn('removeComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* updateComment(action) {
    try {
        setGlobalLoading(true);
        const { param, updateType } = action.payload;
        param.commentStatus = updateType;
        const response = yield api.comment.updateComment(param);
        if (response?.status !== 200) return;
        yield call(getComment, { payload: param?.id });
        yield call(getAllComments, { payload: param?.appId });
    } catch (error) {
        console.warn('updateComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* updateDraftComment(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.updateComment(action.payload);
        if (response?.status !== 200) return;
        yield call(getComment, { payload: action.payload?.id });
    } catch (error) {
        console.warn('updateDraftComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* resolveComment(action) {
    try {
        setGlobalLoading(true);
        const resolvePayload = { ...action.payload };
        resolvePayload.commentStatus = commentStatusEnum.RESOLVED;
        const response = yield api.comment.updateComment(resolvePayload);
        if (response?.status !== 200) return;
        yield call(getAllComments, { payload: action.payload?.appId });
    } catch (error) {
        console.warn('resolveComment', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* updateDraftToPending(action) {
    const response = yield api.comment.updateCommentToPending(action.payload);
}

function* getChangeLogById(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.getChangeLogById(action.payload);
        if (response?.status !== 200) return;
        yield put({
            type: SET_CHANGELOG,
            payload: response?.data?.result?.changeList,
        });
    } catch (error) {
        console.warn('getChangeLogById', error);
    } finally {
        setGlobalLoading(false);
    }

}

function* exportSummary(action) {
    try {
        setGlobalLoading(true);
        const response = yield api.comment.exportSummary(action.payload);
    } catch (error) {
        console.warn('exportSummary', error);
    } finally {
        setGlobalLoading(false);
    }

    // if (response?.status !== 200) return;
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COMMENT:
            return {
                ...state,
                ...action.payload,
            };
        case SET_CURRENT_TAB_ID:
            return {
                ...state,
                currentTabId: action.payload,
            };
        case SET_ALL_COMMENTS:
            return {
                ...state,
                allComments: action.payload,
            };
        case SET_CHANGELOG:
            return {
                ...state,
                changeLog: action.payload,
            };
        default:
            return state;
    }
};

export function* watchComment() {
    yield takeEvery(GET_ALL_COMMENT, safeSaga(getAllComments));
    yield takeEvery(CREATE_COMMENT, safeSaga(createComment));
    yield takeEvery(GET_COMMENT, safeSaga(getComment));
    yield takeEvery(REMOVE_COMMENT, safeSaga(removeComment));
    yield takeEvery(UPDATE_COMMENT, safeSaga(updateComment));
    yield takeEvery(RESOLVE_COMMENT, safeSaga(resolveComment));
    yield takeEvery(UPDATE_DRAFT_COMMENT, safeSaga(updateDraftComment));
    yield takeEvery(UPDATE_ALL_DRAFT_COMMENT, safeSaga(updateDraftToPending));
    yield takeEvery(GET_CHANGELOG_BY_ID, safeSaga(getChangeLogById));
    yield takeEvery(EXPORT_SUMMARY, safeSaga(exportSummary));
}

export default reducer;
